/**
 * <somelys-slider> : carrousel horizontal (scroll-snap) avec flèches précédent / suivant.
 * Les flèches n'apparaissent que si le contenu dépasse la largeur disponible.
 */
class SomelysSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-slider-track]');
    this.prev = this.querySelector('[data-slider-prev]');
    this.next = this.querySelector('[data-slider-next]');
    if (!this.track) return;

    this.prev?.addEventListener('click', () => this.go(-1));
    this.next?.addEventListener('click', () => this.go(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.track);
    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  get step() {
    const slide = this.track.firstElementChild;
    if (!slide) return this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  go(direction) {
    const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
    this.track.scrollBy({ left: this.step * direction * rtl, behavior: 'smooth' });
  }

  update() {
    const overflow = this.track.scrollWidth - this.track.clientWidth > 2;
    this.toggleAttribute('data-overflow', overflow);
    const left = Math.abs(this.track.scrollLeft);
    const max = this.track.scrollWidth - this.track.clientWidth;
    if (this.prev) this.prev.disabled = !overflow || left <= 1;
    if (this.next) this.next.disabled = !overflow || left >= max - 1;
  }
}

if (!customElements.get('somelys-slider')) customElements.define('somelys-slider', SomelysSlider);
